import { render, staticRenderFns } from "./BillingItemList.vue?vue&type=template&id=d263a4be&lang=pug"
import script from "./BillingItemList.vue?vue&type=script&lang=js"
export * from "./BillingItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports